(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7582],{

/***/ 95473:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _ab_button_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(42012);
/* harmony import */ var _ab_button_scss__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_ab_button_scss__WEBPACK_IMPORTED_MODULE_1__);


var Button = function(param) {
    var type = param.type, onClick = param.onClick, href = param.href, target = param.target;
    if (href) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
            className: "ab-button".concat(type ? " ".concat(type) : ""),
            href: href,
            target: target,
            onClick: onClick
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
        className: "ab-button".concat(type ? " ".concat(type) : ""),
        onClick: onClick
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Button);


/***/ }),

/***/ 7582:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ ab_faq_src; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ../node_modules/react-in-viewport/dist/es/index.js
var es = __webpack_require__(28447);
// EXTERNAL MODULE: ../packages/ab-link/src/index.tsx
var src = __webpack_require__(276);
// EXTERNAL MODULE: ../packages/ab-text/src/index.tsx
var ab_text_src = __webpack_require__(145);
// EXTERNAL MODULE: ../packages/ab-button/src/index.tsx
var ab_button_src = __webpack_require__(95473);
;// CONCATENATED MODULE: ../packages/ab-faq/src/MenuItem.tsx




var MenuItem = function(param) {
    var title = param.title, description = param.description;
    var ref = (0,react.useState)(false), isOpen = ref[0], setIsOpen = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "item",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "detail",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ab_text_src/* default */.Z, {
                            element: "h2",
                            children: title
                        }),
                        description ? isOpen ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ab_text_src/* default */.Z, {
                            className: "title",
                            children: isOpen ? description : ""
                        }) : null : null
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ab_button_src/* default */.Z, {
                    type: isOpen ? "menos" : "mas",
                    onClick: function() {
                        return setIsOpen(!isOpen);
                    }
                })
            ]
        })
    });
};
/* harmony default export */ var src_MenuItem = (MenuItem);

// EXTERNAL MODULE: ../packages/ab-paragraph-text/src/index.tsx
var ab_paragraph_text_src = __webpack_require__(2569);
// EXTERNAL MODULE: ../packages/ab-faq/src/faq.scss
var faq = __webpack_require__(32955);
;// CONCATENATED MODULE: ../packages/ab-faq/src/index.tsx








var Faq = function(param) {
    var _title = param.title, title = _title === void 0 ? "Un men\xfa a tu medida" : _title, _text = param.text, text = _text === void 0 ? [] : _text, content = param.content, _items = param.items, items = _items === void 0 ? [] : _items, h1 = param.h1, animated = param.animated, className = param.className, classname = param.classname, navlink = param.navlink, link = param.link;
    // console.log("Faq", items, carta, menu);
    var myRef = (0,react.useRef)();
    var ref = (0,es/* useInViewport */.NM)(myRef, {
        threshold: 0.5
    }, {
        onEnterViewport: function() {
        // console.log("entered viewport");
        }
    }, {
        disconnectOnLeave: false
    }), inViewport = ref.inViewport, enterCount = ref.enterCount, leaveCount = ref.leaveCount;
    var handleScroll = function() {
        var element = document.getElementById("menu-#".concat(navlink));
        var menu = document.getElementById("history-menu");
        if (element) {
            if (inViewport) {
                var ref;
                if (!(element === null || element === void 0 ? void 0 : (ref = element.classList) === null || ref === void 0 ? void 0 : ref.contains("selected"))) {
                    var children = menu === null || menu === void 0 ? void 0 : menu.querySelectorAll("li");
                    children.forEach(function(e) {
                        if (e.id !== element.id) {
                            e === null || e === void 0 ? void 0 : e.classList.remove("selected");
                            e === null || e === void 0 ? void 0 : e.classList.add("not-selected");
                        }
                    });
                    element === null || element === void 0 ? void 0 : element.classList.add("selected");
                    element === null || element === void 0 ? void 0 : element.classList.remove("not-selected");
                    menu.scrollLeft = (element === null || element === void 0 ? void 0 : element.offsetLeft) - 10;
                }
            } else {
                var ref1;
                if (!(element === null || element === void 0 ? void 0 : (ref1 = element.classList) === null || ref1 === void 0 ? void 0 : ref1.contains("not-selected"))) {
                    element === null || element === void 0 ? void 0 : element.classList.remove("selected");
                    element === null || element === void 0 ? void 0 : element.classList.add("not-selected");
                }
            }
        }
    };
    (0,react.useEffect)(function() {
        window.addEventListener("scroll", handleScroll);
        return function() {
            window.removeEventListener("scroll", handleScroll);
        };
    }, [
        inViewport
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                className: "reference",
                style: {
                    top: -100
                },
                id: navlink
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "faq".concat(text.length > 0 || (content === null || content === void 0 ? void 0 : content.length) > 0 ? " padding" : "", " ").concat(className || "", " ").concat(classname || ""),
                ref: myRef,
                children: [
                    h1 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ab_text_src/* default */.Z, {
                        element: "h1",
                        children: h1
                    }) : null,
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "row",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ab_text_src/* default */.Z, {
                                        element: "h2",
                                        animated: animated,
                                        children: title
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ab_paragraph_text_src/* default */.Z, {
                                        text: text,
                                        content: content,
                                        singleColumn: true
                                    })
                                ]
                            }),
                            (items === null || items === void 0 ? void 0 : items.length) <= 4 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "faq-lista",
                                children: [
                                    items === null || items === void 0 ? void 0 : items.map(function(itm, index) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(src_MenuItem, {
                                            title: itm.title,
                                            description: itm.description
                                        }, "menu-item-".concat(index));
                                    }),
                                    link ? /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* default */.Z, {
                                        prefetch: false,
                                        text: link.text || link.title,
                                        href: link.href || link.url,
                                        target: link.target,
                                        style: {
                                            marginTop: 45
                                        }
                                    }) : null
                                ]
                            }) : null
                        ]
                    }),
                    (items === null || items === void 0 ? void 0 : items.length) > 4 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "row two-column",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "faq-lista",
                                    children: items === null || items === void 0 ? void 0 : items.map(function(itm, index) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(src_MenuItem, {
                                            title: itm.title,
                                            description: itm.description
                                        }, "menu-item-".concat(index));
                                    })
                                })
                            }),
                            link ? /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* default */.Z, {
                                prefetch: false,
                                text: link.text || link.title,
                                href: link.href || link.url,
                                target: link.target
                            }) : null
                        ]
                    }) : null
                ]
            })
        ]
    });
};
/* harmony default export */ var ab_faq_src = (Faq);


/***/ }),

/***/ 2569:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var ab_text__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(145);
/* harmony import */ var _ab_paragraph_text_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41257);
/* harmony import */ var _ab_paragraph_text_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_ab_paragraph_text_scss__WEBPACK_IMPORTED_MODULE_3__);




var ParagraphText = function(param) {
    var _text = param.text, text = _text === void 0 ? [] : _text, singleColumn = param.singleColumn, className = param.className, content = param.content, noPlus = param.noPlus;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8;
    var ref9 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), viewMore = ref9[0], setViewMore = ref9[1];
    // console.log("ParagraphText", content, text);
    var parsedHtml = content ? (ref8 = (ref7 = (ref6 = (ref5 = (ref4 = (ref3 = (ref2 = (ref1 = (ref = content === null || content === void 0 ? void 0 : content.replace(/<div>/g, "<p>")) === null || ref === void 0 ? void 0 : ref.replace(/<\/div>/g, "</p>")) === null || ref1 === void 0 ? void 0 : ref1.replace(/<div class/g, "<p class")) === null || ref2 === void 0 ? void 0 : ref2.replace(/<ul>/g, "<p><ul>")) === null || ref3 === void 0 ? void 0 : ref3.replace(/<\/ul>/g, "</ul></p>")) === null || ref4 === void 0 ? void 0 : ref4.replace(/<p>/g, "")) === null || ref5 === void 0 ? void 0 : ref5.replace(/\n/g, "")) === null || ref6 === void 0 ? void 0 : ref6.replace(/\r/g, "")) === null || ref7 === void 0 ? void 0 : ref7.split("</p>")) === null || ref8 === void 0 ? void 0 : ref8.filter(function(e) {
        return e;
    }) : [];
    // console.log("ParagraphText - content", content);
    // console.log("ParagraphText - parsedHtml", parsedHtml);
    // console.log("ParagraphText - text", text);
    if (text.length == 0 && parsedHtml.length == 0) {
        return null;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "ab-paragraph-text ".concat(className || "", " ").concat(viewMore ? "full" : ""),
        style: {
            // height: maxHeight,
            columnCount: singleColumn ? undefined : 2,
            display: singleColumn ? "flex" : "block",
            columnGap: singleColumn ? undefined : 36,
            columnFill: singleColumn ? undefined : "balance"
        },
        children: [
            parsedHtml === null || parsedHtml === void 0 ? void 0 : parsedHtml.map(function(itm, index) {
                if (!itm) {
                    return null;
                }
                if (noPlus) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ab_text__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        className: "no-plus show",
                        children: itm
                    }, "paragraph-text-".concat(index));
                } else if (index == 0 || parsedHtml.length == 1) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ab_text__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        onClick: viewMore ? parsedHtml.length == 1 ? function() {
                            return setViewMore(!viewMore);
                        } : null : function() {
                            return setViewMore(!viewMore);
                        },
                        className: viewMore || parsedHtml.length == 1 ? "no-plus" : index == 0 ? "plus" : undefined,
                        children: itm
                    }, "paragraph-text-".concat(index));
                } else if (parsedHtml.length > 1 && index == parsedHtml.length - 1) {
                    ;
                    if (itm.startsWith("<")) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            dangerouslySetInnerHTML: {
                                __html: itm
                            }
                        });
                    } else {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ab_text__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                            onClick: viewMore ? function() {
                                return setViewMore(!viewMore);
                            } : null,
                            id: viewMore ? "less" : undefined,
                            className: viewMore && (itm === null || itm === void 0 ? void 0 : itm.includes("<ul>")) ? "less" : "",
                            children: itm
                        }, "paragraph-text-".concat(index));
                    }
                }
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ab_text__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                    children: itm
                }, "paragraph-text-".concat(index));
            }),
            text === null || text === void 0 ? void 0 : text.filter(function(e) {
                return e;
            }).map(function(itm, index) {
                if (index == 0 || text.length == 1) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ab_text__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        onClick: viewMore ? text.length == 1 ? function() {
                            return setViewMore(!viewMore);
                        } : null : function() {
                            return setViewMore(!viewMore);
                        },
                        className: viewMore || text.length == 1 ? "no-plus" : index == 0 ? "plus" : undefined,
                        id: viewMore ? "less" : undefined,
                        children: itm
                    }, "paragraph-text-".concat(index));
                } else if (text.length > 1 && index == text.length - 1) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ab_text__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        onClick: viewMore ? function() {
                            return setViewMore(!viewMore);
                        } : null,
                        id: viewMore ? "less" : undefined,
                        children: itm
                    }, "paragraph-text-".concat(index));
                }
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ab_text__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                    children: itm
                }, "paragraph-text-".concat(index));
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ParagraphText);


/***/ }),

/***/ 42012:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 32955:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 41257:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ })

}]);